export const LANGUAGE_SETUP_VERSION = 1;
export const LANGUAGE_STORAGE_KEY = 'bandz-journal-language';

export const SUPPORTED_LANGUAGES = [
  { code: 'en', locale: 'en-US', name: 'English', nativeName: 'English', dir: 'ltr' },
  { code: 'es', locale: 'es-419', name: 'Spanish', nativeName: 'Español', dir: 'ltr' },
  { code: 'pt', locale: 'pt-BR', name: 'Portuguese', nativeName: 'Português', dir: 'ltr' },
  { code: 'fr', locale: 'fr-FR', name: 'French', nativeName: 'Français', dir: 'ltr' },
  { code: 'de', locale: 'de-DE', name: 'German', nativeName: 'Deutsch', dir: 'ltr' },
  { code: 'it', locale: 'it-IT', name: 'Italian', nativeName: 'Italiano', dir: 'ltr' },
  { code: 'nl', locale: 'nl-NL', name: 'Dutch', nativeName: 'Nederlands', dir: 'ltr' },
  { code: 'tr', locale: 'tr-TR', name: 'Turkish', nativeName: 'Türkçe', dir: 'ltr' },
  { code: 'ru', locale: 'ru-RU', name: 'Russian', nativeName: 'Русский', dir: 'ltr' },
  { code: 'ar', locale: 'ar', name: 'Arabic', nativeName: 'العربية', dir: 'rtl' },
  { code: 'hi', locale: 'hi-IN', name: 'Hindi', nativeName: 'हिन्दी', dir: 'ltr' },
  { code: 'zh-CN', locale: 'zh-CN', name: 'Chinese (Simplified)', nativeName: '简体中文', dir: 'ltr' },
  { code: 'ja', locale: 'ja-JP', name: 'Japanese', nativeName: '日本語', dir: 'ltr' },
  { code: 'ko', locale: 'ko-KR', name: 'Korean', nativeName: '한국어', dir: 'ltr' },
  { code: 'id', locale: 'id-ID', name: 'Indonesian', nativeName: 'Bahasa Indonesia', dir: 'ltr' },
];

const LANGUAGE_BY_CODE = new Map(SUPPORTED_LANGUAGES.map((language) => [language.code, language]));

export const isSupportedLanguage = (code) => LANGUAGE_BY_CODE.has(code);

export const getLanguage = (code) => LANGUAGE_BY_CODE.get(code) || LANGUAGE_BY_CODE.get('en');

export const detectSupportedLanguage = (languages = []) => {
  const candidates = Array.isArray(languages) ? languages : [languages];

  for (const candidate of candidates) {
    const normalized = String(candidate || '').trim();
    if (!normalized) continue;
    if (isSupportedLanguage(normalized)) return normalized;

    const base = normalized.toLowerCase().split('-')[0];
    const match = SUPPORTED_LANGUAGES.find((language) => language.code.toLowerCase().split('-')[0] === base);
    if (match) return match.code;
  }

  return 'en';
};

export const getBrowserLanguage = () => {
  if (typeof navigator === 'undefined') return 'en';
  return detectSupportedLanguage(navigator.languages?.length ? navigator.languages : [navigator.language]);
};
